import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Card, Tab, Row, Col, Nav, Button } from 'react-bootstrap';
import FalconCardBody from './FalconCardBody';
import classNames from 'classnames';
import { HashLink } from 'react-router-hash-link';
import Flex from './Flex';
import { useLocation } from 'react-router-dom';
import { camelize } from '../../helpers/utils';
import AppContext from 'context/Context';
import Background from './Background';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

const PreviewCode = () => {
  return (
    <Row>
      <Col>
        <Nav variant="pills" className="nav-pills-falcon m-0">
          <Nav.Item>
            <Nav.Link as={Button} size="sm" eventKey="preview">
              Preview
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Button} size="sm" eventKey="code">
              Code
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Col>
    </Row>
  );
};

const FalconComponentCardHeader = ({
  light,
  className,
  title,
  subtitle,
  onRefresh,
  loading,
  children,
  noPreview,
  endEl,
  image
}) => {
  const location = useLocation();
  const {
    config: { isRTL }
  } = useContext(AppContext);
  return (
    <Card.Header
      className={classNames({ 'bg-light': light }, className)}
      style={{ position: 'relative' }}
    >
      {image && (
        <Background
          image={image}
          className="bg-card"
          style={{
            borderTopRightRadius: '0.375rem',
            borderBottomRightRadius: '0.375rem',
            pointerEvents: 'none'
          }}
        />
      )}
      <Row className="align-items-end g-2">
        <Col>
          {title && (
            <Flex
              justifyContent="between"
              alignItems="center"
              id={camelize(title)}
            >
              <Flex direction="column" className="gap-2">
                <Flex alignItems="center" className="gap-2">
                  <h3 className="mb-0">{title}</h3>
                  {onRefresh && (
                    <Button
                      variant="link"
                      size="sm"
                      className=""
                      title="Refresh"
                      onClick={onRefresh}
                      disabled={loading}
                    >
                      <FontAwesomeIcon icon={faSync} spin={loading} />
                    </Button>
                  )}
                </Flex>
                <h6 className="text-600 mb-0">{subtitle}</h6>
              </Flex>
              {endEl}
            </Flex>
          )}
          {children}
        </Col>
      </Row>
    </Card.Header>
  );
};

const FalconComponentCard = ({
  children,
  multiSections,
  noGuttersBottom,
  ...rest
}) => {
  return (
    <Card className={classNames({ 'mb-3': !noGuttersBottom })} {...rest}>
      {multiSections ? (
        <>{children}</>
      ) : (
        <Tab.Container defaultActiveKey="preview">{children}</Tab.Container>
      )}
    </Card>
  );
};

FalconComponentCard.Header = FalconComponentCardHeader;
FalconComponentCard.Body = FalconCardBody;

FalconComponentCard.propTypes = {
  children: PropTypes.node,
  multiSections: PropTypes.bool,
  noGuttersBottom: PropTypes.bool
};

FalconComponentCardHeader.propTypes = {
  light: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  noPreview: PropTypes.bool,
  endEl: PropTypes.any,
  onRefresh: PropTypes.func,
  loading: PropTypes.bool
};

export default FalconComponentCard;
